<template>
    <span v-if="permiteMostrarDetalheReprovacao">
        <span class="text-primary">
            <i
                class="fa fa-info-circle fa-lg icon-button"
                title="Detalhe da Reprovacao"
                @click.stop="mostrarDetalheReprovacao()"
            ></i>
        </span>
        <b-modal
            id="modalDetalheReprovacao"
            v-model="mostrarModalDetalheReprovacao"
        >
            <div slot="modal-title">Entrega - Detalhe da Reprovação</div>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label for="contato">Detalhe da Reprovação</label>
                        <b-form-textarea
                            v-model="entrega.detalheReprovacao"
                            :rows="4"
                            :disabled="true"
                        >
                        </b-form-textarea>
                    </b-form-group>
                </b-col>
            </b-row>
            <div slot="modal-footer">
                <b-button
                    variant="secondary"
                    @click.stop="fecharDetalheReprovacao()"
                    >Fechar</b-button
                >
            </div>
        </b-modal>
    </span>
</template>

<script>
import { entregaStatus } from './EntregaStatus'

export default {
    props: {
        entrega: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            mostrarModalDetalheReprovacao: false
        }
    },

    methods: {
        mostrarDetalheReprovacao() {
            this.mostrarModalDetalheReprovacao = true
        },

        fecharDetalheReprovacao() {
            this.mostrarModalDetalheReprovacao = false
        }
    },

    computed: {
        permiteMostrarDetalheReprovacao() {
            return (
                this.entrega.status === entregaStatus.REPROVADA ||
                (this.entrega.status === entregaStatus.EM_APROVACAO_GERENTE &&
                    this.entrega.detalheReprovacao)
            )
        }
    }
}
</script>
